export default "__VITE_ASSET__B9D2gpHs__"